exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#smartBox{max-width:450px}@media (max-width:390px){.font{font-size:10px}}@media (min-width:391px) and (max-width:490px){.font{font-size:12px}}", ""]);

// exports
